import { render, staticRenderFns } from "./LinkHome.vue?vue&type=template&id=13bd0788"
import script from "./LinkHome.vue?vue&type=script&lang=js"
export * from "./LinkHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports